import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Services = () => {
  // Handle scrolling to specific service section when page loads with anchor
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Remove the # from hash
      const elementId = hash.substring(1);
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, []);
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div
        className="relative text-white py-20"
        style={{
          backgroundImage: "url('/services/service logo 2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold">OUR SERVICES</h1>
        </div>
      </div>

      {/* Bulk SMS */}
      <div className="py-16 bg-gray-100" id="service1">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/service 4.png"
                alt="Web Development"
                className="max-w-full h-auto object-contain"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-blue-600">BULK SMS</span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                In today's fast-paced business world, companies need faster,
                cheaper, and more reliable ways to communicate with customers.
                Our Bulk SMS service in Kenya makes this possible by allowing
                you to reach thousands of mobile phones in just seconds with a
                single click. With our online bulk SMS platform, there's no need
                for outdated hardware or complicated setups. All you need is an
                internet connection and a browser to start sending messages
                instantly. Whether you're new to SMS marketing or looking for a
                scalable SMS gateway, our platform is simple, powerful, and
                built for results. From transactional alerts to branded SMS
                campaigns, we help businesses engage customers more effectively.
                Trusted by thousands of SMEs, entrepreneurs, and organisations
                across Kenya and East Africa, our affordable bulk SMS solution
                enables you to connect with clients, build loyalty, and grow
                your business.
              </p>

              {/* Action Buttons */}
              <div className="mt-8 space-y-4 sm:space-y-0 sm:space-x-4 sm:flex">
                {/* View Modules Button */}
                <Link
                  to="/bulk-sms-modules"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out group"
                >
                  <span className="mr-2">View Modules</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>

                {/* View Developer Resources Button */}
                <Link
                  to="/developer-resources"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-green-600 to-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:from-green-700 hover:to-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out group relative overflow-hidden"
                >
                  {/* Subtle animated background effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-blue-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

                  <svg
                    className="w-5 h-5 mr-2 transform group-hover:rotate-12 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    ></path>
                  </svg>
                  <span className="relative">View Developer Resources</span>
                  <svg
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300 relative"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* USSD CODES */}
      <div className="py-16 bg-blue-600" id="service2">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Content */}
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-white">USSD CODES</span>
              </h2>
              <p className="text-white text-lg leading-relaxed mb-8">
                USSD (Unstructured Supplementary Service Data) is a mobile
                technology that enables users to access services through an
                interactive menu on any mobile phone with no internet required.
                USSD is widely used for mobile banking, customer self-service,
                mobile surveys, and payment solutions.
                <br />
                <br />
                USSD codes typically begin with * and end with # (for example,
                *100#). When a customer dials a code, they are presented with a
                guided menu of choices, leading to quick and logical outcomes
                such as checking balances, making payments, or submitting
                feedback.
                <br />
                <br />
                With Infinity Tech Africa’s USSD application development in
                Kenya and across East Africa, organisations can deliver:
                <br />
                <br />• <strong>Banking & Payments</strong> – For account
                balance checks, fund transfers, and bill payments.
                <br />
                <br />• <strong>Customer Self-Service</strong> – Customers can
                access account details, request services, or lodge complaints.
                <br />
                <br />• <strong>Surveys & Data Collection</strong> –
                Organisations can run polls and collect insights in real time.
                <br />
                <br />• <strong>Promotions & Loyalty Programs</strong> –
                Business, enterprises and MSMEs can reward customers with
                points, discounts, and offers.
                <br />
                <br />
                Whether costs are borne by the customer or the organisation,
                USSD remains one of the most reliable, affordable, and
                accessible channels for engaging users across Kenya, Tanzania,
                Uganda, Ghana and all across Africa.
              </p>

              {/* Action Buttons */}
              <div className="mt-8 space-y-4 sm:space-y-0 sm:space-x-4 sm:flex">
                {/* View Details Button */}
                <Link
                  to="/ussd-services"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-white text-blue-600 font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-600 hover:text-white transform hover:-translate-y-1 transition-all duration-300 ease-in-out group"
                >
                  <span className="mr-2">View Details</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>

                {/* View Developer Resources Button */}
                <Link
                  to="/developer-resources#top"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-green-500 to-white text-blue-600 font-semibold text-lg rounded-lg shadow-lg hover:from-green-600 hover:to-gray-100 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out group relative overflow-hidden"
                >
                  {/* Subtle animated background effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-green-300 to-blue-100 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>

                  <svg
                    className="w-5 h-5 mr-2 transform group-hover:rotate-12 transition-transform duration-300 relative"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    ></path>
                  </svg>
                  <span className="relative">View Developer Resources</span>
                  <svg
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300 relative"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="order-1 lg:order-2 flex justify-center">
              <img
                src="/services/service 7.png"
                alt="Mobile App Development"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Premium SMS */}
      <div className="py-16 bg-white" id="service3">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image (now on left) */}
            <div className="order-1 lg:order-1 flex justify-center">
              <img
                src="/services/service 5.png"
                alt="Mobile App Development"
                className="max-w-full h-auto object-contain"
              />
            </div>

            {/* Right Side - Content (now on right) */}
            <div className="order-2 lg:order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-blue-600">
                  PREMIUM SMS
                </span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Premium SMS is a simple, fast &amp; reliable mobile payment
                option to monetise your content and services and turn SMS into
                revenue with no apps, no credit cards, and no barriers.
                <br />
                <br />
                Premium SMS is the easiest way for customers to pay directly
                from their mobile phones. With Premium SMS, users are charged a
                slightly higher fee than a normal text message, making it a
                frictionless, accessible payment option for millions of mobile
                subscribers across Kenya and Africa.
              </p>

              {/* View Modules Button */}
              <div className="mt-8">
                <Link
                  to="/premium-sms"
                  className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">View Details</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CHAT Bots */}
      <div className="py-16 bg-blue-600" id="service4">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/service 8.png"
                alt="Web Development"
                className="max-w-full h-auto object-contain"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-white"> CHAT BOTS</span>
              </h2>
              <p className="text-white text-lg leading-relaxed mb-8">
                Chatbots are computer programs designed to simulate conversation
                with human users. They can be used to automate customer service,
                provide information, or even entertain users. Chatbots are
                typically powered by artificial intelligence and natural
                language processing technologies, which enable them to
                understand and respond to user input in a human-like way. They
                can be integrated with messaging platforms like Facebook
                Messenger, WhatsApp, or Slack, making it easy for businesses to
                interact with their customers in real-time. Chatbots are
                becoming increasingly popular in a variety of industries, as
                they offer a cost-effective and efficient way to engage with
                customers and provide personalized experiences.
              </p>
              <div className="mt-8">
                <Link
                  to="/chat-bots"
                  className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-50 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">Explore ChatBots</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stock Management Systems */}
      <div className="py-16 bg-gray-100" id="service5">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Content */}
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-6">
                UZA -{" "}
                <span className="underline decoration-blue-600">
                  STOCK MANAGEMENT SYSTEM{" "}
                </span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                A stock management system is a comprehensive software solution
                designed to help businesses efficiently track, organize, and
                control their inventory across multiple locations. It monitors
                real-time stock levels, records product movements, manages
                supplier information, and automates reordering processes to
                prevent overstocking or stockouts. Additionally, it provides
                businesses with valuable insights into sales trends, inventory
                turnover, and demand forecasting. This system enhances accuracy,
                reduces manual errors, and improves operational efficiency,
                making it easier for businesses to meet customer demand,
                optimize storage space, and make informed purchasing decisions.
              </p>

              {/* Action Buttons */}
              <div className="mt-8 space-y-4 sm:space-y-0 sm:space-x-4 sm:flex">
                {/* Explore UZA System Button */}
                <Link
                  to="/stock-management"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out group"
                >
                  <span className="mr-2">Explore UZA System</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>

                {/* View User Manual Button */}
                <Link
                  to="/developer-resources#uza-manual"
                  className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:from-purple-700 hover:to-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out group relative overflow-hidden"
                >
                  {/* Subtle animated background effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-blue-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>

                  <svg
                    className="w-5 h-5 mr-2 transform group-hover:rotate-12 transition-transform duration-300 relative"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    ></path>
                  </svg>
                  <span className="relative">View User Manual</span>
                  <svg
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300 relative"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="order-1 lg:order-2 flex justify-center">
              <img
                src="/services/service 1.png"
                alt="Stock Management System"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Email Service */}
      <div className="py-16 bg-indigo-600" id="service6">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/EmailService.png"
                alt="Email Service Integration"
                className="max-w-full h-auto object-contain rounded-xl opacity-90"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                INFINITY  -{" "}
                <span className="underline decoration-white">
                  EMAILPRO
                </span>
              </h2>
              <p className="text-white text-lg leading-relaxed mb-8">
                Infinity Emailpro is a simple, reliable &amp; professional email
                delivery service that helps you reach your customers instantly
                with a powerful email marketing and transactional email platform
                designed for African businesses.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link
                  to="/email-service"
                  className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-700 text-white font-semibold text-lg rounded-lg shadow-lg hover:from-purple-700 hover:to-indigo-800 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out border-2 border-white/20"
                >
                  <span className="mr-2">Explore Emailpro</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
                <Link
                  to="/developer-resources"
                  className="inline-flex items-center px-8 py-4 bg-white text-indigo-600 font-semibold text-lg rounded-lg shadow-lg hover:bg-indigo-50 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">View API Documentation</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>

                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Software Development */}
      <div className="py-16 bg-white" id="service7">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Content */}
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-blue-600">
                  SOFTWARE DEVELOPMENT
                </span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                We create modern, responsive, and user-friendly websites that
                help businesses establish a strong online presence. Our web
                development services include custom website design, e-commerce
                platforms, content management systems, and web applications.
                Using the latest technologies and best practices, we ensure your
                website is fast, secure, and optimized for search engines. From
                simple business websites to complex web applications, we deliver
                solutions that meet your specific requirements and help you
                achieve your digital goals while providing an excellent user
                experience across all devices.
              </p>
              <div className="mt-8">
                <Link
                  to="/software-development"
                  className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">Explore Development Services</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="order-1 lg:order-2 flex justify-center">
              <img
                src="/services/service 3.png"
                alt="SMS Solutions"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Gaming Service */}
      <div className="py-16 bg-indigo-600" id="service8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/service 9.png"
                alt="Gaming Service Monetization"
                className="max-w-full h-auto object-contain rounded-xl opacity-90"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-white">
                  DIGITAL SERVICES
                </span>
              </h2>
              <p className="text-white text-lg leading-relaxed mb-8">
                Our Digital Services platform empowers game developers and publishers to
                effortlessly monetize their mobile games through direct carrier
                billing. We specialize in seamless subscription management with
                Safaricom's network, enabling users to subscribe with just their
                phone number - no cards or wallets required. Our robust API
                handles everything from user authentication to subscription
                renewals, letting you focus on creating amazing digital
                experiences while we handle the payments. We offer flexible
                billing cycles including daily, weekly, and monthly
                subscriptions to match your game's specific needs. With
                real-time payment notifications and webhook integrations, you
                get instant confirmation of successful subscriptions and
                renewals. Our developer-friendly REST API comes with
                comprehensive documentation and dedicated support to ensure
                smooth integration. Transform your games into sustainable
                revenue streams with zero payment friction for your users.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link
                  to="/gaming-service"
                  className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-700 text-white font-semibold text-lg rounded-lg shadow-lg hover:from-purple-700 hover:to-indigo-800 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out border-2 border-white/20"
                >
                  <span className="mr-2">Explore Digital Services</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
                <Link
                  to="/developer-resources"
                  className="inline-flex items-center px-8 py-4 bg-white text-indigo-600 font-semibold text-lg rounded-lg shadow-lg hover:bg-indigo-50 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">View API Documentation</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>

                
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* School Management Systems */}
      <div className="py-16 bg-gray-100" id="service9">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/service 2.png"
                alt="School Management System"
                className="max-w-full h-auto object-contain"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-blue-600">
                  SCHOOL MANAGEMENT SYSTEM
                </span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                A comprehensive software solution that helps educational
                institutions efficiently track, manage, and organize all aspects
                of school operations across multiple locations. It monitors
                student information in real-time, records academic progress,
                manages staff information, and automates administrative
                processes to prevent data loss or miscommunication.
                Additionally, it provides schools with valuable insights into
                student performance, attendance trends, and resource allocation.
                This system enhances accuracy, reduces manual errors, and
                improves operational efficiency, making it easier for schools to
                meet educational standards, optimize resource usage, and make
                informed administrative decisions.
              </p>
              <div className="mt-8">
                <Link
                  to=""
                  className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">Service Coming Soon</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Solutions */}
      <div className="py-16 bg-blue-600" id="service10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="order-1 flex justify-center">
              <img
                src="/services/service 6.png"
                alt="Web Development"
                className="max-w-full h-auto object-contain"
              />
            </div>

            {/* Right Side - Content */}
            <div className="order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                SMS Africa -{" "}
                <span className="underline decoration-white">
                  PAYMENT SYSTEM
                </span>
              </h2>
              <p className="text-white text-lg leading-relaxed mb-8">
                Our payment integration services enable businesses to securely
                and easily accept payments online. We specialize in integrating
                payment gateways like Pesapal, PayPal,M-pesa, and other popular
                payment providers with your website or mobile app, so you can
                start accepting payments in no time. Our team of experienced
                developers will work closely with you to ensure that the payment
                integration is seamless and meets your specific requirements. We
                offer a range of payment integration options to suit your
                business needs, including one-time payments, recurring payments,
                subscriptions, and more. With our payment integration services,
                you can streamline your payment processes, reduce transaction
                costs, and provide a better user experience for your customers.
                Contact us today to learn more about how we can help your
                business grow with our payment integration services.
              </p>
              <div className="mt-8">
                <Link
                  to=""
                  className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold text-lg rounded-lg shadow-lg hover:bg-blue-50 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                >
                  <span className="mr-2">Service Coming Soon</span>
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      {/* Footer Section */}
      <footer className="bg-blue-600 text-white py-12">
          <div className="max-w-7xl mx-auto px-6">
            
            {/* Top 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-b border-blue-500 pb-10">
              
              {/* About Us */}
              <div className="space-y-3 md:border-r border-white md:pr-6">
                <h3 className="text-lg font-bold mb-2">About Us</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="about" className="hover:text-blue-200">Who we are</a></li>
                  <li><a href="about" className="hover:text-blue-200">News Hub</a></li>
                  <li><a href="about" className="hover:text-blue-200">Our Reach</a></li>
                  
                </ul>
              </div>

              {/* Customer Service */}
              <div className="space-y-3 md:border-r border-white md:px-6">
                <h3 className="text-lg font-bold mb-2">Customer Service</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="contact" className="hover:text-blue-200">Message Us</a></li>
                  
                  <li><a href="contact" className="hover:text-blue-200">Comment/Complaint</a></li>
                </ul>
              </div>

              {/* Join + Payment */}
              <div className="space-y-4 md:pl-6">
                
                <div>
                <h4 className="text-sm font-semibold mb-2">Payment Options</h4>
                <div className="flex space-x-4">
                  <img src="/icons/mpesa2.png" alt="Visa" className="h-12 object-contain" />
                  <img src="/icons/mastercard.png" alt="Mastercard" className="h-6 object-contain" />
                  <img src="/icons/visa.png" alt="Amex" className="h-6 object-contain" />
                </div>
              </div>
              </div>
            </div>

            {/* Contact Icons Section */}
            <div className="flex justify-center mt-8 mb-6">
              <div className="flex items-center space-x-6 bg-green-700 px-8 py-4 rounded-lg shadow-lg">
                <span className="text-sm font-semibold">Get in Touch:</span>
                <a 
                  href="tel:+254722943271" 
                  className="bg-white hover:bg-blue-100 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="Call us"
                >
                  <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </a>
                <a 
                  href="https://wa.me/254722943271" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white hover:bg-green-50 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="WhatsApp us"
                >
                  <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="flex justify-center">
              <div className="flex space-x-4 border border-white p-3 rounded">
                <a href="https://www.facebook.com/SMSAfrica01?mibextid=wwXIfr&rdid=M64RTVM7l0SsUXbw&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D45K1gBPv%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer"><img src="/icons/facebook.png" alt="Facebook" className="w-6 h-6" /></a>
                <a href="https://www.linkedin.com/company/infinity-tech-africa/" target="_blank" rel="noopener noreferrer"><img src="/icons/linkedin.png" alt="LinkedIn" className="w-6 h-6" /></a>
                <a href="https://www.instagram.com/smsafrica/profilecard/?igsh=eXgwOHBydWdlZGVi" target="_blank" rel="noopener noreferrer"><img src="/icons/email.png" alt="Email" className="w-6 h-6" /></a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><img src="/icons/x logo.png" alt="Twitter" className="w-6 h-6" /></a>
                <a href="https://www.tiktok.com/@infinitytechafrica?_t=ZM-8xr2bhp0ey0&_r=1" target="_blank" rel="noopener noreferrer"><img src="/icons/tiktok logo2.png" alt="YouTube" className="w-6 h-6" /></a>
              </div>
            </div>

            {/* Bottom Footer */}
            <div className="text-center pt-6 mt-6 border-t border-blue-500 text-sm">
              <p>
  &copy; 2025 Infinity Tech Africa |{' '}
  <a
    href="/privacy-policy.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-200 underline"
  >
    Privacy Policy
  </a>{' '}
  | Terms & Conditions Apply
</p>
            </div>
          </div>
        </footer>
    </div>
  );
};

export default Services;
